import { AdminApi } from 'stylemix-vue-admin'

export default class VehicleAvailabilityApi extends AdminApi {
  constructor(parameters = {}) {
    super('vehicle-availability-rules', parameters)
  }
}
